import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { CreateProjectConnectionPage } from "./pages/create-or-edit/CreateProjectConnectionPage";
import { EditProjectConnectionPage } from "./pages/create-or-edit/EditProjectConnectionPage";
import { CreateProjectConnectionGroupPage } from "./pages/groups-create-or-edit/CreateProjectConnectionGroupPage";
import { EditProjectConnectionGroupPage } from "./pages/groups-create-or-edit/EditProjectConnectionGroupPage";
import { ListProjectConnectionGroupsPage } from "./pages/groups-list/ListProjectConnectionGroupsPage";
import { ListConnectionsPage } from "./pages/list/ListConnectionsPage";
import {
  canListProjectConnectionGroups,
  canListProjectConnections,
  canManageProjectConnectionGroups,
  canManageProjectConnections,
} from "./permissions";
import { projectConnectionsRoutes } from "./routes";

export const projectConnectionsRoute = [
  {
    path: projectConnectionsRoutes.list,
    element: (
      <RequireAuth permission={canListProjectConnections}>
        <ListConnectionsPage />
      </RequireAuth>
    ),
  },
  {
    path: projectConnectionsRoutes.create,
    element: (
      <RequireAuth permission={canManageProjectConnections}>
        <CreateProjectConnectionPage />
      </RequireAuth>
    ),
  },
  {
    path: projectConnectionsRoutes.edit,
    element: (
      <RequireAuth permission={canManageProjectConnections}>
        <EditProjectConnectionPage />
      </RequireAuth>
    ),
  },
  {
    path: projectConnectionsRoutes.listGroups,
    element: (
      <RequireAuth permission={canListProjectConnectionGroups}>
        <ListProjectConnectionGroupsPage />
      </RequireAuth>
    ),
  },
  {
    path: projectConnectionsRoutes.createGroup,
    element: (
      <RequireAuth permission={canManageProjectConnectionGroups}>
        <CreateProjectConnectionGroupPage />
      </RequireAuth>
    ),
  },
  {
    path: projectConnectionsRoutes.editGroup,
    element: (
      <RequireAuth permission={canManageProjectConnectionGroups}>
        <EditProjectConnectionGroupPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
